import React from "react"
import styled from "styled-components"

const StyledFooterBlock = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-inline-start: 1rem;
  margin-top: 2rem;

  p {
    line-height: 1.4;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`

export default function FooterBlock() {
  return (
    <StyledFooterBlock>
      <p>フランソアグループ</p>
    </StyledFooterBlock>
  )
}
